// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DH1G","label":"styles_label__1fQK_"};